import * as angular from 'angular';

export class Controller {

    /** @ngInject */
    constructor($scope) {
        this.$scope = $scope;
    }

    $onChanges() {
        this.init();
    }

    $onInit() {
        this.init();
        this.watch();
    }

    init() {
        this.$model = this.loginServicesConfiguration;
        this.model = angular.copy(this.$model);
    }

    instantLoginUrlEnabled() {
        return this.model.instantLoginEnabled || this.model.proximityEnabled || this.model.pushLoginEnabled;
    }

    mobileApplicationSettingsChanged($value, $invalid) {
        this.model.mobileApplicationSettings = $value;
        this.onChange({$value: this.model, $invalid: $invalid || this.form.$invalid});
    }

    notModified() {
        return angular.equals(this.$model, this.model);
    }

    onKeyUp($event) {
        if ($event.keyCode === 13 && this.form.$valid && !this.notModified()) {
            this.onEnter();
        }
    }

    watch() {
        this.$scope.$watch(
            () => this.model,
            () => this.onChange({$value: this.model, $invalid: this.form.$invalid}),
            true
        );
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/configuration/login-services-form.controller.js